<div class="document-sender-picker">
  @if (activeSender) {
    <span class="acting-as">
      Acting as {{ activeSender.firstName }} {{ activeSender.lastName }}
      <button
        type="button"
        class="document-sender-clear"
        (click)="onClear()"
        [matTooltip]="'Stop acting as ' + activeSender.firstName + ' ' + activeSender.lastName"
        matTooltipPosition="below"
        [matTooltipShowDelay]="500"
        aria-label="Clear document sender"
      >
        <mat-icon fontIcon="close"></mat-icon>
      </button>
    </span>
  }

  <button
    type="button"
    class="document-sender-trigger"
    [class.document-sender-trigger--active]="isOpen"
    (click)="toggle()"
    matTooltip="Document sender"
    matTooltipPosition="below"
    [matTooltipShowDelay]="500"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isOpen"
    aria-label="Choose document sender"
  >
    <mat-icon fontIcon="person"></mat-icon>
    <mat-icon fontIcon="expand_more" class="document-sender-trigger-chevron"></mat-icon>
  </button>
</div>

@if (isOpen) {
  <div class="document-sender-popup-backdrop" (click)="close()"></div>
  <div class="document-sender-popup-anchor">
    <div class="document-sender-popup-notch" aria-hidden="true"></div>
    <div class="document-sender-popup" role="dialog" aria-modal="true" aria-label="Choose document sender">
      <header class="document-sender-popup-header">
        <mat-icon fontIcon="person" class="document-sender-popup-icon"></mat-icon>
        <span class="document-sender-popup-title">Document sender</span>
        <button
          class="document-sender-popup-close"
          type="button"
          aria-label="Close popup"
          matTooltip="Close"
          matTooltipPosition="below"
          [matTooltipShowDelay]="500"
          (click)="close()"
        >
          <mat-icon fontIcon="close"></mat-icon>
        </button>
      </header>

      <div class="document-sender-popup-search-wrapper">
        <mat-icon fontIcon="person" class="document-sender-popup-search-icon document-sender-popup-search-icon--left"></mat-icon>
        <input
          #searchInput
          class="document-sender-popup-search"
          type="text"
          placeholder="Search by name or ID…"
          [formControl]="filterCtrl"
        />
        <mat-icon fontIcon="search" class="document-sender-popup-search-icon document-sender-popup-search-icon--right"></mat-icon>
      </div>

      @if (loading) {
        <ul class="document-sender-popup-list" aria-hidden="true">
          @for (row of skeletonRows; track $index) {
            <li class="document-sender-popup-row document-sender-popup-row--skeleton">
              <span class="document-sender-popup-row-label">
                <app-skeleton [style]="row.nameStyle"></app-skeleton>
                <app-skeleton [style]="row.emailStyle"></app-skeleton>
              </span>
            </li>
          }
        </ul>
      } @else if (filteredSenders.length > 0) {
        <ul class="document-sender-popup-list">
          @for (sender of filteredSenders; track sender.id) {
            <li class="document-sender-popup-row" (click)="onSelected(sender)">
              <span class="document-sender-popup-row-label">
                <span class="document-sender-popup-row-name">{{ sender.name }}</span>
                @if (sender.email) {
                  <span class="document-sender-popup-row-email">{{ sender.email }}</span>
                }
              </span>
            </li>
          }
        </ul>
      } @else {
        <p class="document-sender-popup-empty">No matches</p>
      }
    </div>
  </div>
}
